<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled"
                 ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="py-3 px-2 max-h-64 overflow-y-auto w-full z-30">
                <div class="space-y-6">
                    <div v-if="rfmMaterials.length > 0">
                        <div class="flex text-xs font-medium text-gray-400 mb-1">
                            <div class="ml-2 flex-grow">Outstanding Request for Materials</div>
                            <div class="flex-shrink mr-2">Requested</div>
                        </div>
                        <div class="space-y-1">
                            <div
                                v-for="section in rfmMaterials"
                                class="flex space-x-2 text-left w-full text-gray-500 pl-2 pr-0 py-0"
                                :title="section.name"
                            >
                                <template v-if="section.id">
                                    <div class="truncate flex-1 flex flex-col">
                                        <div class="truncate w-full py-1" v-text="section.name"></div>
                                        <div
                                            v-for="task in section.tasks"
                                            class="flex space-x-2 text-left w-full pl-2 pr-0 py-0"
                                            :title="task.reference+' - '+task.name"
                                        >
                                            <div class="truncate flex-1 flex flex-col">
                                                <div class="truncate w-full py-1"
                                                     v-text="task.reference+' - '+task.name"></div>
                                                <div
                                                    v-for="item in task.items"
                                                    class="flex space-x-2 text-left w-full pl-2 pr-0 py-0"
                                                    :title="item.reference+' - '+item.name"
                                                >
                                                    <div class="truncate flex-1 flex flex-col">
                                                        <div class="truncate w-full py-1"
                                                             v-text="item.reference+' - '+item.name"></div>
                                                        <div
                                                            v-for="rfm in item.rfms"
                                                            class="flex space-x-2 text-left w-full pl-2 pr-0 py-0"
                                                            :title="rfm.reference"
                                                        >
                                                            <div class="truncate flex-1 flex flex-col">
                                                                <div class="truncate w-full py-1"
                                                                     v-text="rfm.reference"></div>

                                                                <div
                                                                    v-for="material in rfm.materialItems"
                                                                    class="flex space-x-2 text-left w-full rounded-md pl-1 pr-0 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                                                    :title="material.name"
                                                                >
                                                                    <div
                                                                        class="truncate flex-1 flex flex-col text-blue-500">
                                                                        <div class="truncate w-full">
                                                                            <div
                                                                                class="truncate text-sms mx-0 py-0.5 px-1">
                                                                                <button
                                                                                    @mousedown="(e) => selectMaterial(e,material,rfm, close)"
                                                                                    class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                                                                >
                                                <span class="flex-1 flex flex-grow mx-1 relative truncate">
                                                    <span class="flex-grow truncate">
                                                {{ material.material }}
                                                    <span v-if="material.unitOfMeasure"
                                                          class="italic"> - ({{ material.unitOfMeasure }})</span>
                                                    </span>
                                                    <span class="flex-shrink mr-4" v-if="material.required"
                                                          v-text="material.required">
                                                    </span>
                    <div class="absolute text-green-400 right-0 top-0.5 pt-px z-20"
                         v-if="purchaseOrderItem.resolves.some((i) => i.rfm.id === rfm.id && i.rfm.item.id === material.id )">
                        <span class="fa fa-star" style="font-size: 10px"></span>
                    </div>

                                                </span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="truncate flex-1 flex flex-col">
                                        <div class="truncate w-full py-1 text-red-500" v-text="section.name"></div>
                                        <div
                                            v-for="rfm in section.rfms"
                                            class="flex space-x-2 text-left w-full pl-2 pr-0 py-0"
                                            :title="rfm.reference"
                                        >
                                            <div class="truncate flex-1 flex flex-col">
                                                <div class="truncate w-full py-1"
                                                     v-text="rfm.reference"></div>

                                                <div
                                                    v-for="material in rfm.materialItems"
                                                    class="flex space-x-2 text-left w-full rounded-md pl-1 pr-0 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                                    :title="material.name"
                                                >
                                                    <div
                                                        class="truncate flex-1 flex flex-col text-blue-500">
                                                        <div class="truncate w-full">
                                                            <div class="truncate text-sms mx-0 py-0.5 px-1">
                                                                <button
                                                                    @mousedown="(e) => selectMaterial(e,material,rfm, close)"
                                                                    class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                                                >
                                                <span class="flex-1 flex flex-grow mx-1 relative truncate">
                                                    <span class="flex-grow truncate">
                                                {{ material.material }}
                                                    <span v-if="material.unitOfMeasure"
                                                          class="italic"> - ({{ material.unitOfMeasure }})</span>
                                                    </span>
                                                    <span class="flex-shrink mr-4" v-if="material.required"
                                                          v-text="material.required">
                                                    </span>
                    <div class="absolute text-green-400 right-0 top-0.5 pt-px z-20"
                         v-if="purchaseOrderItem.resolves.some((i) => i.rfm.id === rfm.id && i.rfm.item.id === material.id )">
                        <span class="fa fa-star" style="font-size: 10px"></span>
                    </div>

                                                </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="(rfms.length ===0)" class="text-gray-500 text-sm pl-2">
                        No outstanding Request for Materials.
                    </div>
                    <div v-else-if="(rfmMaterials.length ===0)" class="text-gray-500 text-sm pl-2">
                        No matching materials in found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import UiInput from "../../ui/UiInput.vue";
import {ProcurementRequestForMaterials, PurchaseOrder} from "@models";
import UiDropdown from "../../ui/UiDropdown.vue";
import {cloneDeep} from "lodash";

export default {
    components: {UiDropdown, UiInput},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        current: Object,
        enabled: true,
        purchaseOrder: Object,
        purchaseOrderItem: Object,
    },
    data() {
        return {
            materials: [],
            resourcePlanningReport: Object,
            rfms: [],
            rfmMaterials: [],
        }
    },
    watch: {
        "purchaseOrderItem.packageReference": {
            handler(newValue, oldValue) {
                this.reloadMaterials()
            },
        },
    },
    computed: {},
    methods: {
        matchMaterial(materialName) {
            if (!this.current.description) return true;
            const query = ('' + this.current.description).toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (materialName).toLowerCase().includes(token)
            });
        },
        scope(dropdownScope) {
            return {
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        async setQuery(query, open = true) {
            this.buildTree();
            if (open) {
                this.$refs.dropdown.close();
                this.$refs.dropdown.open();
            }
        },
        async selectMaterial(event, material, rfm, close) {
            if (event.ctrlKey || event.metaKey) {
                this.$emit('selected:addMaterial', rfm, material);
            } else {
                this.$emit('selected:material', rfm, material);
                close()
            }
        },
        clear(close) {
            close();
        },
        close() {
            this.$refs.dropdown.close();
        },
        focus() {
            this.$refs.searchInput.focus();
        },
        buildTree() {
            let tree = [];
            let addToTree = (rfm, section, task, item, requestedMaterial) => {
                if (!section || !task || !item) {
                    let s = tree.find((i) => i.id == null);
                    if (!s) {
                        s = {id: null, name: 'Not set items', rfms: []}
                        tree.push(s);
                    }
                    let r = s.rfms.find((i) => i.id === rfm.id);
                    if (!r) {
                        r = {id: rfm.id, reference: 'RFM #' + rfm.reference, materialItems: []}
                        s.rfms.push(r);
                    }
                    let m = cloneDeep(requestedMaterial);
                    r.materialItems.push(m);
                } else {
                    let s = tree.find((i) => i.id === section.id);
                    if (!s) {
                        s = {id: section.id, name: section.name, tasks: []}
                        tree.push(s);
                    }
                    let t = s.tasks.find((i) => i.id === task.id);
                    if (!t) {
                        t = {id: task.id, name: task.name, reference: task.reference, items: []}
                        s.tasks.push(t);
                    }
                    let i = t.items.find((i) => i.id === item.id);
                    if (!i) {
                        i = {id: item.id, name: item.name, reference: item.reference, rfms: []}
                        t.items.push(i);
                    }
                    let r = i.rfms.find((i) => i.id === rfm.id);
                    if (!r) {
                        r = {id: rfm.id, reference: 'RFM #' + rfm.reference, materialItems: []}
                        i.rfms.push(r);
                    }
                    let m = cloneDeep(requestedMaterial);
                    r.materialItems.push(m);
                }
            }
            if (this.rfms) {
                this.rfms.forEach(rfm => {
                    if ((rfm.status === 'Partially Resolved') || (rfm.status === 'Acknowledged')) {
                        rfm.items.forEach(item => {
                            if (this.matchMaterial(item.material)) {
                                addToTree(rfm, item.section, item.task, item.item, item);
                            }
                        })
                    }
                })
            }
            tree.forEach(section => {
                if (section.tasks) {
                    section.tasks.forEach(task => {
                        task.items.forEach(item => {
                            item.rfms.forEach(rfm => {
                                rfm.materialItems.sort((a, b) => b.required - a.required);
                            })
                        })
                    })
                } else {
                    section.rfms.forEach(rfm => {
                        rfm.materialItems.sort((a, b) => b.required - a.required);
                    })
                }
            })
            this.rfmMaterials = tree;
        },
        async reloadMaterials() {
            this.rfms = await ProcurementRequestForMaterials.all(this.purchaseOrderItem.packageReference);
        }
    },
    async mounted() {
        this.reloadMaterials();
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
